import { BootstrapFormRenderer } from './BootstrapFormRenderer.js';

export function configure(config) {
	config.container.registerHandler('bootstrap', (container) => container.get(BootstrapFormRenderer));
}
